import OLLayerTile from 'ol/layer/Tile'
import OLSourceTileWMS from 'ol/source/TileWMS'

import type { TileImage } from 'ol/source'
import type { Options as TileWMSOptions } from 'ol/source/TileWMS'

import * as Model from 'api/model'
import * as PoziUtils from 'api/utils'
import type { ConfigLayerOptions } from 'config/ConfigLayer'
import type { ConfigLayerBaseTileOptions } from 'config/ConfigLayerBaseTileOptions'
import { MapLayerWMS } from 'config/MapLayerWMS'
import type { TileLoad } from 'config/TileLoad'
import { setLayerLoadDone } from 'drawer/tabs/layers/actions'

import SetAttributions from './SetAttributions'

export interface ConfigLayerTileWMSAuthOptions extends ConfigLayerOptions {
  config: TileWMSOptions
}

export class MapLayerTileWMSAuth extends MapLayerWMS {
  static createLayer (layerConf: ConfigLayerTileWMSAuthOptions): OLLayerTile<TileImage> {
    this.preLayer(layerConf)

    let authkey = ''
    if (layerConf.config && layerConf.config.params && layerConf.config.params.authkey) {
      authkey = layerConf.config.params.authkey
    }

    // FIXME: The function definition below needs to be elaborated
    // @ts-ignore
    layerConf.config.tileLoadFunction = function (tile: TileLoad, src: string) {
      const xhr = new window.XMLHttpRequest()
      xhr.open('GET', src)
      xhr.responseType = 'arraybuffer'
      xhr.setRequestHeader('authkey', authkey)
      // xhr.withCredentials = true
      // xhr.setRequestHeader('pozicfcacheurl', src) // TODO: Research if this is needed for CF cache?
      xhr.onload = function () {
        const arrayBufferView = new Uint8Array(this.response)
        const blob = new window.Blob([arrayBufferView], { type: 'image/png' })
        const urlCreator = window.URL || window.webkitURL
        const imageUrl = urlCreator.createObjectURL(blob)
        tile.getImage().src = imageUrl
      }
      xhr.send()
    }

    const olSourceTileWMS2 = new OLSourceTileWMS(layerConf.config)
    const baseTileOptions: ConfigLayerBaseTileOptions = {
      title: layerConf.title,
      titleid: layerConf.titleid,
      group: layerConf.group,
      source: olSourceTileWMS2,
      maxResolution: layerConf.maxResolution || 100000,
      maxZoom: layerConf.maxZoom,
      minResolution: layerConf.minResolution || 0.0001,
      minZoom: layerConf.minZoom,
      opacity: layerConf.opacity || 1,
      visible: PoziUtils.isLayerSelected(layerConf, true)
    }
    const olLayer = new OLLayerTile(baseTileOptions)
    PoziUtils.setSourceLoaded(olLayer, olSourceTileWMS2, layerConf)

    // Hack to mark layer as loaded once 1 tile has successfully loaded. We do this because
    // OL has no event for when all tiles have loaded
    olSourceTileWMS2.once('tileloadend', () => {
      // Set in old model
      Model.set('app.config.layerbytitleid[' + layerConf.titleid + '].loaded', true)

      // Set in redux
      window.store.dispatch(setLayerLoadDone(layerConf.titleid))
    })

    olSourceTileWMS2.on('tileloaderror', function (event) {
      // const errorMsg = 'Layer load failed ' + layerConf.title
      // PoziUtils.gtag({
      //   category: 'data',
      //   status: 'warning',
      //   identifier: layerConf.title,
      //   action: 'ajax request',
      //   additionalInfo: errorMsg
      // })
      console.error('TileWMSAuth tile load error for layer ' + layerConf.title, event)
    })

    // Automatically derive the legend URL from the layer configuration, if not provided yet
    this.autoGenerateLegendUrl(layerConf, olLayer)

    // Add attributions for Nearmap layers
    // TODO: do this in a better way
    const url = PoziUtils.getLayerUrl(layerConf) || ''
    if (olSourceTileWMS2 && url.includes('nearmap.com')) {
      const attributions = [
        '<a target="_blank" rel="noopener noreferrer" href="https://nearmap.com">© Nearmap</a>'
      ]

      SetAttributions(olLayer, attributions, true)
    }

    return olLayer
  }
}
